// Statik veri katmanı: kurumlar paketten gelir; haberler (varsa) Cloudflare Worker /
// API'den çekilir, olmazsa pakete gömülü anlık görüntüye düşer. Sunucu bağımlılığı yok.
import brokersData from "../data/brokers.json";
import newsSnapshot from "../data/news.json";

const NEWS_API = process.env.REACT_APP_NEWS_API || "";

let _newsCache = null;

async function loadNews() {
  if (_newsCache) return _newsCache;
  if (NEWS_API) {
    try {
      const r = await fetch(`${NEWS_API}/news?limit=40`);
      if (r.ok) {
        const d = await r.json();
        if (d && Array.isArray(d.news) && d.news.length) {
          _newsCache = d.news;
          return _newsCache;
        }
      }
    } catch (e) {
      /* çevrimdışı / worker yok → anlık görüntü */
    }
  }
  _newsCache = newsSnapshot;
  return _newsCache;
}

export const NEWS_FALLBACK =
  "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

const matches = (b, q) =>
  b.name.toLowerCase().includes(q) ||
  (b.phone || "").toLowerCase().includes(q) ||
  (b.email || "").toLowerCase().includes(q);

export const getBrokers = async (q) => {
  const ql = (q || "").trim().toLowerCase();
  const brokers = ql ? brokersData.filter((b) => matches(b, ql)) : brokersData;
  return { count: brokers.length, brokers };
};

export const getPopularBrokers = async () => {
  const brokers = brokersData
    .filter((b) => b.is_popular)
    .sort((a, b) => a.popular_order - b.popular_order);
  return { brokers };
};

export const getBroker = async (slug) => {
  const b = brokersData.find((x) => x.slug === slug);
  if (!b) throw new Error("not_found");
  return b;
};

export const getNews = async (limit = 30) => {
  const news = await loadNews();
  return { count: news.length, news: news.slice(0, limit) };
};

export const getNewsItem = async (id) => {
  const news = await loadNews();
  const item = news.find((n) => n.id === id);
  if (!item) throw new Error("not_found");
  return item;
};
